import { render, staticRenderFns } from "./CreateDriver.vue?vue&type=template&id=44789cfd&scoped=true&"
import script from "./CreateDriver.vue?vue&type=script&lang=js&"
export * from "./CreateDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44789cfd",
  null
  
)

export default component.exports